export default __webpack_public_path__ + "static/media/gallery-wip-cover_00.5c00eea8.jpg";